import { Chat, ChatResponseModeEnum, ChatRoleEnum } from 'types/chat'
import { DateTime } from 'luxon'
import { t } from 'i18next'
import { store } from 'store/index'
import { messagesSelectors } from 'store/messages'
import _ from 'lodash'
import { User } from 'types/user'

export const formatDateWithDurationCalculation = (dateISO: string) => {
  const now = DateTime.now()
  const luxonDate = DateTime.fromISO(dateISO)
  const isToday = luxonDate.toISODate() === now.toISODate()
  const isYesterday = luxonDate.toISODate() === now.minus({ days: 1 }).toISODate()
  const isSameWeek = luxonDate.toISODate() === now.minus({ days: 7 }).toISODate()

  if (isToday) {
    return luxonDate.toFormat('HH:mm')
  }
  if (isYesterday) {
    return t('yesterday')
  }
  if (isSameWeek) {
    return luxonDate.toFormat('EEEE')
  }
  return luxonDate.toFormat('dd/MM/yyyy')
}
export const getChatDateFormatted = (chat: Chat) => {
  const { updatedAt, createdAt } = chat
  if (updatedAt) {
    return formatDateWithDurationCalculation(updatedAt)
  }
  return formatDateWithDurationCalculation(createdAt)
}

export const findParticipantsByRole = (chat: Chat, chatRole: ChatRoleEnum) => {
  const currentChatParticipants = chat?.participants || []
  return currentChatParticipants.find((participant) => participant.role === chatRole)
}

export const findCurrentChatParticipantsByRole = (chatRole: ChatRoleEnum) => {
  const state = store.getState()
  const currentChat = messagesSelectors.currentChat(state)
  const currentChatParticipants = currentChat?.participants || []
  return currentChatParticipants.find((participant) => participant.role === chatRole)
}

export const chatIsToRead = (chat: Chat, currentUser?: User) => {
  const currentUserParticipant = _.find(chat?.participants, (p) => p?.userId === currentUser?._id)
  if (!currentUserParticipant || _.isNil(chat.lastMessage)) return false
  if (!currentUser) return false
  if (chat.responseMode === ChatResponseModeEnum.BOT) {
    return false
  }

  const currentUserLastReadTimeStamp = Number(_.get(currentUserParticipant, 'lastReadTimestamp', 0))
  const lastMessageTimestamp = _.get(chat, 'lastMessage.timestamp', 0)
  const lastMessageUserId = _.get(chat, 'lastMessage.senderId')

  // console.debug({
  //   currentUserParticipant,
  //   currentUserLastReadTimeStamp,
  //   currentUserLastReadTimeStampDate: DateTime.fromMillis(currentUserLastReadTimeStamp).toFormat(defaultDateTimeFormat),
  //   lastMessageTimestamp,
  //   lastMessageTimestampDate: DateTime.fromMillis(lastMessageTimestamp).toFormat(defaultDateTimeFormat),
  //   lastMessageUserId
  // })

  if (currentUserLastReadTimeStamp < lastMessageTimestamp && currentUser._id !== lastMessageUserId) {
    console.debug('not read')
    return true
  } else {
    console.debug('read')
    return false
  }
}
